import React from 'react';
import VoucherPage from './VoucherPage';

const VpsOnPage: React.FC = () => {
  return <VoucherPage category="vpsOn" />;
};

export default VpsOnPage;

